import { errorMessage } from "helpers/utils";
import { call, put, takeEvery } from "redux-saga/effects";
import NotificationManagementService from "services/NotificationManagementService";
import {
  detailNotificationFail,
  detailNotificationSuccess,
  listNotificationFail,
  listNotificationHeaderFail,
  listNotificationHeaderSuccess,
  listNotificationSuccess,
} from "store/actions";
import {} from "./actions";
import {
  NOTIFICATION_DETAIL,
  NOTIFICATION_HEADER_LIST,
  NOTIFICATION_LIST,
} from "./actionTypes";

function* fetchListNotification({ payload }) {
  try {
    const response = yield call(
      NotificationManagementService.listNotification,
      payload
    );
    yield put(listNotificationSuccess(response));
  } catch (error) {
    yield put(listNotificationFail(errorMessage(error)));
  }
}

function* fetchListNotificationHeader({ payload }) {
  try {
    const response = yield call(
      NotificationManagementService.listNotificationHeader,
      payload
    );
    yield put(listNotificationHeaderSuccess(response));
  } catch (error) {
    yield put(listNotificationHeaderFail(errorMessage(error)));
  }
}

function* onDetailNotification({ payload }) {
  try {
    const response = yield call(
      NotificationManagementService.detailNotification,
      payload
    );
    yield put(detailNotificationSuccess(response));
  } catch (error) {
    yield put(detailNotificationFail(errorMessage(error)));
  }
}

function* notificationManagementSaga() {
  yield takeEvery(NOTIFICATION_LIST, fetchListNotification);
  yield takeEvery(NOTIFICATION_HEADER_LIST, fetchListNotificationHeader);
  yield takeEvery(NOTIFICATION_DETAIL, onDetailNotification);
}

export default notificationManagementSaga;
